<div class="grid product-card" *ngIf="productData != undefined ">
    <div class="product-card__image">
        <picture class="base-card__image">

            <source media="(min-width: 600px)" srcset="{{image_url + productData.image_url}}.png">
            <img class="img-responsive" src="{{image_url + productData.image_url}}-mobile.png" alt="360 photo place">
        </picture>
        <span *ngIf="productData.discount > 0 " class="discount-rate bg-tertiary-base text-grayscale-white text-xsmall">-{{productData.discount}}%</span>
    </div>
    <div class="product-card__info">
        <button class="btn-card text-left" type="button" (click)="openDetailDialog()">{{productData.name}}<span class="icon icon-arrow-right"></span></button>
        <p class="description" [innerHTML]="productData.summary" >{{productData.summary}}</p>
        <span *ngIf="productData.id == 2" class="modal" (click)="openDetailDialog()">Conocer más</span>
        <span *ngIf="productData.id == 3" class="modal" (click)="openDetailDialog()">Conocer más</span>
        <div class="selection">
            <span class="selection__price">${{productData.priceDiscount.toLocaleString()}}</span>
            <div class="selection__picker-group">
                <button type="button" class="btn-picker" (click)='remove()' onclick="dataLayer.push({
            '​event':​ ​'removeFromCart',​
            '​ecommerce':​ {
            ​'remove'​: {
            'products': [{
              'name': productData.name,
              '​id'​: productData.id,
              'price': productData.price,
              '​brand':​ ​'Google',​
              '​category': 'Publicacion',​
              '​variant'​:'​Gray',​
              '​quantity':​ ​1,
            }],
          }}});"><span class="material-icons">remove</span></button>
                <span>{{count}}</span>
                <button type="button" class="btn-picker" (click)='add()' onclick="dataLayer.push({ '​event':​ ​'addToCart'​, '​ecommerce':​ {
            ​'currencyCode':​'​COP'​,'add':​ { '​products'​: [{
            ​'name':​ productData.name,
            ​'id'​: productData.id,​
            ​'price'​:​​ productData.price,
            'category':​​​'Publicacion',
            'quantity':​ ​productData.quantity
            }]}}
            });"><span class="material-icons">add</span></button>
            </div>
        </div>
    </div>
</div>